import { PartyService } from 'src/app/services/api/party/party.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { CoverageService } from 'src/app/services/api/coverage/coverage.service';
import saveAs from 'file-saver';
import { NotificationsService, NotificationLevel } from 'src/app/services/api/notifications/notifications.service';
import moment from 'moment';

enum CoverageFileState {
  UNKNOWN, EMPTY, GENERATING, AVAILABLE
}

@Component({
  selector: 'app-coverage-download',
  templateUrl: './coverage-download.component.html',
  styleUrls: ['./coverage-download.component.scss']
})
export class CoverageDownloadComponent implements OnInit, OnDestroy {
  isps: any[];
  selectedIsp: any;
  currentState: CoverageFileState;
  stateCallback: number;
  deleteCallback: number;
  deleteRetries: number;

  constructor(private breadcrumbsService: BreadcrumbsService, private coverageService: CoverageService,
    private partyService: PartyService, private notificationsService: NotificationsService) {


  }

  public get coverageFileState(): typeof CoverageFileState {
    return CoverageFileState;
  }

  ngOnInit() {
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs: [
          { title: 'Administración', url: 'provision/management' },
          { title: 'Cobertura FTTH', url: 'provision/management/coverage' },
          { title: 'Descarga de cobertura', url: 'provision/management/coverage/download' }
        ]
      }
    );

    this.isps = [];
    this.deleteRetries = 0;

    this.currentState = CoverageFileState.UNKNOWN;
    this.partyService.getCustomers().subscribe(
      (data) => {
        for (const party of data) {
          this.isps.push({ name: party.name, code: party.namingId });
        }
        this.selectedIsp = this.isps[0];
        this.getCoverageFileDownloadState();
      }
    );
  }

  getCoverageFileDownloadState() {
    this.coverageService.getCoverageFileDownloadState(this.selectedIsp.name.toLowerCase().replace(/[\s]/g, ''))
      .subscribe(
        (state) => {
          this.processResponseState(state);
        },
        (error) => {
          this.notificationsService.showNotification(
            'Ha ocurrido un error al obtener el estado de los ficheros. Por favor, vuelva a generar el fichero para este ISP',
            NotificationLevel.ERROR);
          this.deleteCoverageFile(this.selectedIsp.name.toLowerCase().replace(/[\s]/g, ''));
        });
  }

  ispChange() {
    this.currentState = CoverageFileState.UNKNOWN;
    this.getCoverageFileDownloadState();
  }

  async processResponseState(state: any): Promise<void> {
    if (this.stateCallback !== undefined) {
      clearTimeout(this.stateCallback);
    }
    if (state.finished) {
      if (state.resultado === 'OK') {
        this.currentState = CoverageFileState.AVAILABLE;
      } else if (state.resultado === 'NOK') {
        this.currentState = CoverageFileState.EMPTY;
      }
    } else {
      this.currentState = CoverageFileState.GENERATING;
      this.stateCallback = setTimeout(this.getCoverageFileDownloadState.bind(this), 10000) as any;
    }
  }

  async deleteCoverageFile(isp: string): Promise<void> {
    if (this.deleteCallback !== undefined) {
      clearTimeout(this.deleteCallback);
    }
    this.coverageService.deleteIspCoverageFile(this.selectedIsp.name.toLowerCase().replace(/[\s]/g, ''))
      .subscribe(
        (result) => {
          this.deleteRetries = 0;
          this.getCoverageFileDownloadState();
        },
        (error) => {
          if (this.deleteRetries < 12) {
            this.deleteRetries++;
            this.deleteCallback = setTimeout(this.deleteCoverageFile.bind(this), 10000) as any;
          }
        });
  }

  public downloadFile() {
    this.coverageService.downloadCoverage(this.selectedIsp.name.toLowerCase().replace(/[\s]/g, '')).subscribe(
      (data) => {
        const blob = new Blob([data], { type: 'text/csv' });
        saveAs(blob, 'CH_500_' + this.selectedIsp.code + '_' + moment().format('YYYYMMDD') + '.csv');
      },
      (error) => {
        this.notificationsService.showNotification(
          'Ha ocurrido un error al descargar el fichero', NotificationLevel.ERROR
        );
      }
    )
  }

  public generateFile() {
    this.currentState = CoverageFileState.GENERATING;
    this.coverageService.generateIspCoverageFile(this.selectedIsp.name.toLowerCase().replace(/[\s]/g, '')).subscribe(
      (data) => {
        this.getCoverageFileDownloadState();
      },
      (error) => {
        this.notificationsService.showNotification(
          'Ha ocurrido un error al intentar generar el fichero', NotificationLevel.ERROR
        );
        this.getCoverageFileDownloadState();
      }
    )
  }

  ngOnDestroy() {
    if (this.deleteCallback !== undefined) {
      clearTimeout(this.deleteCallback);
    }
    if (this.stateCallback !== undefined) {
      clearTimeout(this.stateCallback);
    }
  }

}
